module.exports = __webpack_public_path__ + "static/media/barrel3.f656a15d.jpg";